// extracted by mini-css-extract-plugin
export default {"container":"ToggleProjectMembersView-module__container___k4Ki7","toggleText":"ToggleProjectMembersView-module__toggleText___mgrfv"};